import whatInput from "what-input";

export const isTouchInput = (): boolean => {
    return whatInput.ask("intent") === "touch";
};

export const isKeyboardInput = (): boolean => {
    return whatInput.ask("intent") === "keyboard";
};

export const isMouseInput = (): boolean => {
    return whatInput.ask("intent") === "mouse";
};

const getCurrentInput = (): string => {
    return whatInput.ask("intent");
};

export default getCurrentInput;
